<template>
  <!-- «Табличка» ключевых чисел, как легенда на полях топокарты. -->
  <dl class="grid border border-border rounded-lg bg-muted/40" :class="gridCols">
    <div
      v-for="(item, i) in items"
      :key="item.label"
      data-plate-cell
      class="px-3 py-2 min-w-0"
      :class="i % columns !== 0 && 'border-l border-border'"
      :title="item.hint"
    >
      <dt class="text-[11px] text-muted-foreground truncate">{{ item.label }}</dt>
      <!-- Число с единицей не вылезает за ячейку: длинные значения («5 ч 48 мин»)
           переносятся по пробелам, число и его единица держатся вместе. -->
      <dd class="mt-1 text-[15px] font-semibold leading-tight flex flex-wrap items-baseline gap-x-1">
        <span v-for="(chunk, ci) in chunks(item.value)" :key="ci" data-plate-chunk class="num whitespace-nowrap">{{ chunk }}<span v-if="item.unit && ci === chunks(item.value).length - 1" class="ml-0.5 text-[12px] font-normal text-muted-foreground">{{ item.unit }}</span></span>
      </dd>
    </div>
  </dl>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{ items: { label: string; value: string; unit?: string; hint?: string }[]; columns?: 2 | 3 | 4 }>(),
  { columns: 4 }
);
// «5 ч 48 мин» -> ["5 ч", "48 мин"]: число держится со своей единицей, а между
// такими кусками ячейка может перенести строку.
const chunks = (value: string): string[] => value.match(/\S+(?:\s+[^\d\s+]\S*)?/g) ?? [value];
const gridCols = computed(() => ({ 2: "grid-cols-2", 3: "grid-cols-3", 4: "grid-cols-4" })[props.columns]);
</script>
